import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count"]
  static values = { limit: Number }

  connect() {
    this.update()
    this.inputTarget.addEventListener("input", this.handleInput.bind(this))
  }

  handleInput() {
    const input = this.inputTarget
    if (input.value.length > this.limitValue) {
      input.value = input.value.slice(0, this.limitValue)
    }
    this.update()
  }

  update() {
    const length = this.inputTarget.value.length
    this.countTarget.textContent = `${length}/${this.limitValue}`
  }
}
